import { render, staticRenderFns } from "./FormMercadoPago.vue?vue&type=template&id=5be731cb&scoped=true&"
import script from "./FormMercadoPago.vue?vue&type=script&lang=js&"
export * from "./FormMercadoPago.vue?vue&type=script&lang=js&"
import style0 from "./FormMercadoPago.vue?vue&type=style&index=0&id=5be731cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be731cb",
  null
  
)

export default component.exports